import { IconButton, Box, Typography } from '@material-ui/core'
import CodeIcon from '@material-ui/icons/Code'

import { CopyCodeDialog } from './CopyCodeDialog'

import { useBoolean, useNotification } from 'hooks'

type Props = {
    playbookId: string
    playbookTitle: string
    isPlaylist?: boolean
    disabled: boolean
}

export const CopyEmbedCode = ({ playbookId, playbookTitle, isPlaylist, disabled }: Props) => {
    const showDialog = useBoolean()

    const { showWarningNotification } = useNotification()

    const handleIconClick = () => {
        if (disabled)
            return showWarningNotification(
                'The video privacy settings require you to share it with anyone in order to embed it'
            )

        showDialog.setTrue()
    }

    return (
        <Box>
            <Box
                display="flex"
                justifyContent="start"
                alignItems="center"
                flexDirection="column"
                onClick={handleIconClick}
            >
                <IconButton
                    size="small"
                    title="Copy embed code"
                    style={{ background: '#CD0000', opacity: disabled ? 0.5 : 1 }}
                >
                    <CodeIcon style={{ color: 'white' }} />
                </IconButton>
                <Typography variant="body2">Embed</Typography>
            </Box>

            {showDialog.isTrue && (
                <CopyCodeDialog
                    isOpen={true}
                    onClose={showDialog.setFalse}
                    title="Embed code"
                    playbookId={playbookId}
                    playbookTitle={playbookTitle}
                    isPlaylist={isPlaylist}
                />
            )}
        </Box>
    )
}
